import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-home-page',
  imports: [CommonModule],
  styleUrl:'home-page.css',
  templateUrl: './home-page.html'
})
export class HomePage {
 
  constructor(){    
  }




  
 
  

}